import { useMutation, useQueryClient } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { startImportFromNkp } from '../api/importService';
export var TRITIUS_NKP_URL = 'https://aleph.nkp.cz/data/aut_tritius.xml.gz';
/**
 * Hook for triggering an NK Tritius authority import.
 * On success, invalidates both batch-list and active-batch queries so UI updates.
 */
var useStartImport = function () {
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function () { return startImportFromNkp(ky, TRITIUS_NKP_URL, 'REPLACE'); }, {
        onSuccess: function () {
            queryClient.invalidateQueries(['czna-import-batches']);
            queryClient.invalidateQueries(['czna-import-active']);
        },
    });
};
export default useStartImport;
